module.exports = __webpack_public_path__ + "img/eye-evil.67ca03cc.svg";